import React from 'react';
import s from './index.module.scss';

function Details (props) {
	return (
		<div className={s.details}>
			<div className={s.closeArea} onClick={props.onClickBack} />
			<div className={s.content}>
				<button className={s.back} onClick={props.onClickBack} type="button" />
				<h2 className={s.title} dangerouslySetInnerHTML={{ __html: props.answerData.title }} />
				<p className={s.text} dangerouslySetInnerHTML={{ __html: props.answerData.text }} />
			</div>
		</div>
	);
}

export default Details;
